import { Component, ViewChild } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

import { SVGIcon, filePdfIcon, fileExcelIcon } from '@progress/kendo-svg-icons';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import Swal from 'sweetalert2';

import { TooltipDirective } from '@progress/kendo-angular-tooltip';

import _ from 'lodash';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { process, State } from '@progress/kendo-data-query';
import {
  SelectableSettings,
  SelectableMode,
} from '@progress/kendo-angular-grid';
import {
  orderBy,
  SortDescriptor,
  filterBy,
  CompositeFilterDescriptor,
  FilterDescriptor,
} from '@progress/kendo-data-query';
import {
  FormArray,
  FormControl,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

import {
  FilterableSettings,
  DataBindingDirective,
  GridDataResult,
  PageChangeEvent,
  DataStateChangeEvent,
  GridComponent,
} from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs';

import { Router } from '@angular/router';
import { Store, compose, select } from '@ngrx/store';
import { LoaderService } from '../../core/services/loader.service';
import { SharedService } from '../../shared/shared.service';
import { Validations } from '../../shared/constants/validations';
import { PdfexportService } from '../../core/services/pdfexport.service';
import { Roles, SweetAlertIcon } from '../../shared/constants/enum';
import { PaymentLinkService } from '../../core/services/paymentLink.service';
import { UserService } from '../../core/services/user.service';
import { table_pageSize } from '../../shared/constants/templatesNames';
import { Helper } from '../../core/helpers/helper';

@Component({
  selector: 'app-trisource-settlement',
  templateUrl: './trisource-settlement.component.html',
  styleUrl: './trisource-settlement.component.scss',
  standalone: false,
})
export class TrisourceSettlementComponent {
  public mySelection: any = [];
  public selectableSettings!: SelectableSettings;
  public selectableSettingsWalletBalance!: SelectableSettings;
  public selectableSettingswalletHistory!: SelectableSettings;
  public checkboxOnly = true;
  public drag = false;
  public mode: SelectableMode = 'multiple';
  orderByQuery: string = '';
  queryString: string = '';

  walletUitqueryString: string = '';
  walletorderByQuery: string = '';

  walletBalanceOrderQuery: string = '';
  walletBalancequeryString: string = '';
  Submitted: boolean = false;
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective | undefined;
  public TriSourceSettlementState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  projectValidations = Validations.trisourceSettlement;
  public TriSourceSettlementgridData: GridDataResult = { data: [], total: 0 };
  public walletUnitgridData: GridDataResult = { data: [], total: 0 };
  public walletBalancegridData: GridDataResult = { data: [], total: 0 };
  pTriSourceSettlementDataList: any[] = [];
  TriSourceSettlementDataListtotalCount: number = 0;
  walletUnitHistoryListtotalCount: number = 0;
  walletBalanceListtotalCount: number = 0;
  public pageSize = 10;
  public walletUnitpageSize = 10;
  public walletBalancepageSize = 10;

  public skip = 0;
  walletBalanceSkip = 0;
  walletUnitSkip = 0;
  trisourceSettlementSkip = 0;
  currentUserData: any;
  public filterMode: FilterableSettings = 'row';
  public filePdfIcon: SVGIcon = filePdfIcon;
  public fileExcelIcon: SVGIcon = fileExcelIcon;
  breadCrumbItems: Array<{}> | undefined;
  public sort: SortDescriptor[] = [];
  public filter: CompositeFilterDescriptor = { logic: 'and', filters: [] };
  public TriSourceSettlementpageSizes = true;
  public TriSourceSettlementpreviousNext = true;
  public previousNext = true;
  public WalletpreviousNext = true;
  public WalletBalancepreviousNext = true;
  public customFilterState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  public trisourceState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  public WalletUnitState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  public WalletBalanceState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  public pageSizes = table_pageSize.pageSizes;
  public walletpageSizes = table_pageSize.pageSizes;
  public walletUitpageSizes = table_pageSize.pageSizes;
  consumerForm!: UntypedFormGroup;
  public buttonCount = 5;
  Roles = Roles;
  selectedConsumers: any[] = [];
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';
  searchedValue: any = '';
  triSourcesearchedValue = '';
  @ViewChild('pdfGrid') public hiddenGrid: GridComponent | undefined;
  @ViewChild('walletUnitpdfGrid') public walletUnitpdfGrid:
    | GridComponent
    | undefined;
  @ViewChild('walletBalancepdfGrid') public walletBalancepdfGrid:
    | GridComponent
    | undefined;
  modelRef_1!: BsModalRef;
  constructor(
    private modalService: BsModalService,
    private sharedService: SharedService,
    private paymentLinkService: PaymentLinkService,
    private router: Router,
    private userService: UserService,
    private store: Store,
    private loaderService: LoaderService,
    private formBuilder: UntypedFormBuilder,
    private PdfexportService: PdfexportService
  ) {
    this.breadCrumbItems = [{ label: 'Solar Settlement' }];
    const currentUserString = localStorage.getItem('currentUser');
    this.currentUserData = JSON.parse(currentUserString ?? '');
    this.selectableSettings = {
      checkboxOnly: this.checkboxOnly,
      mode: this.mode,
      drag: this.drag,
    };
    this.selectableSettingsWalletBalance = {
      checkboxOnly: this.checkboxOnly,
      mode: this.mode,
      drag: this.drag,
    };
    this.selectableSettingswalletHistory = {
      checkboxOnly: this.checkboxOnly,
      mode: this.mode,
      drag: this.drag,
    };
  }
  ConsumerList: any[] = [];
  triSourceSettlementList: any[] = [];
  walletUnitHistoryList: any[] = [];
  walletBalanceList: any[] = [];
  consumerFlatDeatils:any

  ngOnInit(): void {
    this.loaderService.setLoading(true);
    this.consumerForm = this.formBuilder.group({
      ConsumerIDs: [, Validators.required],
      UnitRate: [false],
      unitPrice: [''],
    });

    this.consumerForm.get('UnitRate')?.valueChanges.subscribe((value) => {
      if (value == true) {
        this.consumerForm.get('unitPrice')?.setValidators([
          Validators.required,
          Helper.maxValueValidator(99999),
          Helper.PatternValidator(/^([1-9]\d*|0)?(\.\d+)?$/),
          //  Helper.PatternValidator(/^(?!0+(\.0+)?$)([1-9]\d*|0)?(\.\d+)?$/),
        ]);
        this.consumerForm.get('unitPrice')?.updateValueAndValidity();
      } else {
        this.consumerForm.get('unitPrice')?.clearValidators();
        this.consumerForm.get('unitPrice')?.updateValueAndValidity();
      }
    });
    this.tabChange({
      selectedIndex: 0,
    });
    // this.getPAi();
  }
  consumertrisourceFlatdetails() {
    this.userService.ConsumertrisourceFlatdetails().subscribe({
      next: (res) => {
        console.log(res)
        this.consumerFlatDeatils = res.data;
        this.loaderService.setLoading(false);
      }, error: (err) => {
        console.log(err);
        this.loaderService.setLoading(false);

        // Check if backend returned an error.message
        const errorMsg =
          err.error?.message ||
          'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR
        );
      },

    })

  }
  walletBalnceApi() {
    //zero tab
    let consumerId =
      this.currentUserData.currentUserRoleDetails.role == this.Roles.CONSUMER
        ? this.currentUserData.currentUserRoleDetails?.userId
        : '';
    console.log(consumerId);
    this.userService
      .getWalletbalance(
        this.walletBalanceCurrentPage,
        this.walletBalancepageSize,
        this.triSourcesearchedValue,
        this.walletBalancequeryString,
        this.currentUserData.project.id,
        this.walletBalanceOrderQuery,
        consumerId,
        this.currentUserData.currentUserRoleDetails.role
      )
      .subscribe({
        next: (res) => {
          if (res.statusCode == 200) {
            console.log(res);
            this.walletBalanceList = [...res.data.items];
            this.walletBalancepageSize = res.data.pageSize;
            this.walletBalanceListtotalCount = res.data.totalCount;
            this.loadWalletBalanceGridTable();
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);
        },
      });
    //getWalletbalance
  }
  getPAi() {
    //tab 2
    let isSettelment: boolean = true;
    let consumerId =
      this.currentUserData.currentUserRoleDetails.role == this.Roles.CONSUMER
        ? this.currentUserData.currentUserRoleDetails?.userId
        : '';
    console.log(consumerId);

    this.userService
      .getTrisourceSettlements(
        this.triSourcecuurrentPage,
        this.pageSize,
        this.triSourcesearchedValue,
        this.queryString,
        this.currentUserData.project.id,
        this.orderByQuery,
        isSettelment,
        consumerId
      )
      .subscribe({
        next: (res) => {
          console.log(res);
          if (res.statusCode == 200) {
            this.triSourceSettlementList = [...res.data.items];
            this.pageSize = res.data.pageSize;
            this.TriSourceSettlementDataListtotalCount = res.data.totalCount;
            this.loadTriSourceGridTable();
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);
        },
      });
  }

  walletUnitgetPAi() {
    //tab 1
    let isSettelment: boolean = false;
    let consumerId =
      this.currentUserData.currentUserRoleDetails.role == this.Roles.CONSUMER
        ? this.currentUserData.currentUserRoleDetails?.userId
        : '';
    console.log(consumerId);
    this.userService
      .getTrisourceSettlements(
        this.walletunitCurrentpage,
        this.walletUnitpageSize,
        this.triSourcesearchedValue,
        this.walletUitqueryString,
        this.currentUserData.project.id,
        this.walletorderByQuery,
        isSettelment,
        consumerId
      )
      .subscribe({
        next: (res) => {
          if (res.statusCode == 200) {
            console.log(res);
            this.walletUnitHistoryList = [...res.data.items];
            this.walletUnitpageSize = res.data.pageSize;
            this.walletUnitHistoryListtotalCount = res.data.totalCount;
            this.loadWalletUnitGridTable();
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);
        },
      });
  }

  loadTriSourceGridTable() {
    //tab 2
    const state: any = {
      take: this.pageSize,
      sort: this.sort,
      filter: {
        logic: 'and',
        filters: [],
      } as CompositeFilterDescriptor,
    };
    const processedData = process(this.triSourceSettlementList, state);
    console.log('processed', JSON.stringify(processedData));
    this.TriSourceSettlementgridData = {
      data: processedData.data,
      total: this.TriSourceSettlementDataListtotalCount,
    };

    this.TriSourceSettlementgridData.data =
      this.TriSourceSettlementgridData.data.map((invoice) => {
        console.log(new Date(invoice.currentBillGeneratedDate));
        return {
          ...invoice,
          currentBillGeneratedDate: invoice.currentBillGeneratedDate
            ? this.sharedService.dateFormateChnagewithoutTime(
              invoice.currentBillGeneratedDate
            )
            : '',
          created_Date: invoice.createdOn
            ? this.sharedService.dateFormateChnagewithoutTime(invoice.createdOn)
            : '',
        };
      });
    this.loaderService.setLoading(false);

    console.log(this.TriSourceSettlementgridData);
  }

  loadWalletBalanceGridTable() {
    //  zero tab
    const state: any = {
      take: this.walletBalancepageSize,
      sort: this.sort,
      filter: {
        logic: 'and',
        filters: [],
      } as CompositeFilterDescriptor,
    };
    const processedData = process(this.walletBalanceList, state);
    //console.log("processed",JSON.stringify(processedData));
    this.walletBalancegridData = {
      data: processedData.data,
      total: this.walletBalanceListtotalCount,
    };

    this.loaderService.setLoading(false);

    // console.log(this.walletBalancegridData);
  }

  loadWalletUnitGridTable() {
    //tab 1
    const state: any = {
      take: this.walletUnitpageSize,
      sort: this.sort,
      filter: {
        logic: 'and',
        filters: [],
      } as CompositeFilterDescriptor,
    };
    const processedData = process(this.walletUnitHistoryList, state);
    //console.log("processed",JSON.stringify(processedData));
    this.walletUnitgridData = {
      data: processedData.data,
      total: this.walletUnitHistoryListtotalCount,
    };

    this.walletUnitgridData.data = this.walletUnitgridData.data.map(
      (invoice) => {
        // console.log(new Date(invoice.currentBillGeneratedDate));
        return {
          ...invoice,
          currentBillGeneratedDate: invoice.currentBillGeneratedDate
            ? this.sharedService.dateFormateChnagewithoutTime(
              invoice.currentBillGeneratedDate
            )
            : '',
          created_On: invoice.createdOn
            ? this.sharedService.dateFormateChnagewithoutTime(invoice.createdOn)
            : '',
        };
      }
    );
    this.loaderService.setLoading(false);

    console.log(this.walletUnitgridData);
  }

  get ConsumerControls() {
    return this.consumerForm.controls;
  }
  openSettlement(addUmd: any) {
    this.Submitted = false;
    this.selectedConsumers = [];
    //  this.ConsumerIDs;
    this.loaderService.setLoading(true);
    this.userService
      .getuserByProjects(this.currentUserData.project.id)
      .subscribe({
        next: (res) => {
          if (res.statusCode == 200) {
            //this.ConsumerList = [...res.data];
            this.ConsumerList = [
              {
                id: 'all',
                userName: 'All Consumers',
              },
              ...(res.data || []), // Use an empty array if data.data.utilities is undefined
            ];

            this.loaderService.setLoading(false);
          }
          //   console.log('res--->', this.ConsumerList);
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);
        },
      });
      this.consumerForm.reset();
    this.modelRef_1 = this.modalService.show(addUmd, {
      class: 'modal-dialog-centered',
      backdrop: 'static', //
    });
  }

  onCheckboxChange(event: any) {
    console.log(event.target.checked);
    if (event.target.checked == true) {
    }
  }

  ConsumersChange(event: any) {
    console.log(event);
    // console.log(this.selectedConsumers);

    const term = typeof event === 'string' ? event : '';
    const contains =
      (value: string) => (item: { userName: string; id: string }) =>
        item.userName.toLowerCase().includes(value.toLowerCase());

    // Check if configData, data, and projects exist before filtering
    if (this.ConsumerList) {
      this.ConsumerList = this.ConsumerList.filter(contains(term));
    }
    // this.selectedUtilityType = event;}
  }

  exportAll() {
    this.loaderService.setLoading(true);
    let isSettelment: boolean = false;
    this.userService
      .exportAllrisourceSettlements(
        this.currentUserData.project.id,
        this.walletUnitHistoryListtotalCount,
        isSettelment
      )
      .subscribe({
        next: (res) => {
          console.log(res);
          if (res.data.items.length > 0) {
            console.log(res);
            this.loaderService.setLoading(false);
            let alltrisourceSettlements = [...res.data.items];
            const transformedData = alltrisourceSettlements.map(
              (item: any) => ({
                'Consumer Name': item.consumerName,
                'Flat No': item.flatNo,
                'Bill No': item.billNo,
                'Device Sr No': item.meterSerialNo,
                'Mac Address': item.macAddress,
                'Old Units': item.oldBalance + ' KWh',
                'New units': item.newBalance + ' KWh',
                'Bill Generated Date':
                  item.createdOn != null
                    ? this.sharedService.dateFormateChnagewithoutTime(item.createdOn)
                    : '',
                'Bill Date':
                  item.currentBillGeneratedDate != undefined
                    ? this.sharedService.dateFormateChnagewithoutTime(
                      item.currentBillGeneratedDate
                    )
                    : '',
                'Adjusted Units': item.units + ' KWh',
                'Unit Status': item.transactionType,
              })
            );
            this.PdfexportService.downloadExcel(
              transformedData,
              'Unit History'
            );
          } else {
            this.loaderService.setLoading(false);
            this.sharedService.showMessageDialog(
              'No data to available',
              '',
              SweetAlertIcon.ERROR
            );
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);
        },
      });

    //  this.currentUserData.project.id,
  }
  SettlementexportAll() {
    this.loaderService.setLoading(true);
    let isSettelment: boolean = true;
    this.userService
      .exportAllrisourceSettlements(
        this.currentUserData.project.id,
        this.walletUnitHistoryListtotalCount,
        isSettelment
      )
      .subscribe({
        next: (res) => {
          console.log(res);
          if (res.data.items.length > 0) {
            console.log(res);
            this.loaderService.setLoading(false);
            let alltrisourceSettlements = [...res.data.items];
            const transformedData = alltrisourceSettlements.map(
              (item: any) => ({
                'Consumer Name': item.consumerName,
                'Flat No': item.flatNo,
                'Meter Serial No': item.meterSerialNo,
                'Mac Address': item.macAddress,
                'Old Units': item.oldBalance + ' KWh',
                'New units': item.newBalance + ' KWh',
                'Amount Settled': item.walletAddedAmout,
                'Settlement Date':
                  item.createdOn != null
                    ? this.sharedService.dateFormateChnagewithoutTime(
                      item.createdOn
                    )
                    : '',
                'Units Deducted': item.units + ' KWh',
                'Unit Rate': item.unitPrice,
                'Settlement Type': item.settlementType,
              })
            );
            this.PdfexportService.downloadExcel(
              transformedData,
              'Settlement Unit History'
            );
          } else {
            this.loaderService.setLoading(false);
            this.sharedService.showMessageDialog(
              'No data to available',
              '',
              SweetAlertIcon.ERROR
            );
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);
        },
      });

    //  this.currentUserData.project.id,
  }
  UnitBalanceExportAll() {
    this.loaderService.setLoading(true);
    //this.walletBalanceListtotalCount
    // this.walletBalnceApi();
    this.userService
      .exportexcelWalletBalance(
        this.currentUserData.project.id,
        this.walletBalanceListtotalCount
      )
      .subscribe({
        next: (res) => {
          // console.log(res);
          if (res.data.items.length > 0) {
            // console.log(res);
            this.loaderService.setLoading(false);
            let allResidentilaunitList = [...res.data.items];
            const transformedData = allResidentilaunitList.map((item: any) => ({
              'Consumer Name': item.consumerName,
              'Flat No': item.flatNo,
              'Current Balance Unit': item.extraUnits,
            }));
            // console.log(transformedData)
            this.PdfexportService.downloadExcel(
              transformedData,
              'Unit Balance'
            );
          } else {
            this.loaderService.setLoading(false);
            this.sharedService.showMessageDialog(
              'No data to available',
              '',
              SweetAlertIcon.ERROR
            );
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);
        },
      });
  }

  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;

    // Check if the element is a table cell
    if (element.nodeName === 'TD') {
      const cellValue = element.innerText.trim();

      // Only show the tooltip if the cell is not empty, null, or ''
      if (cellValue && !element.closest('.no-tooltip')) {
        this.tooltipDir?.toggle(element);
      } else {
        this.tooltipDir?.hide();
      }
    } else if (element.classList.contains('k-column-title')) {
      this.tooltipDir?.toggle(element);
    } else {
      this.tooltipDir?.hide();
    }
  }

  customDateFiltersQueryEq: any[] = [];
  customDateFiltersQueryNEQ: any[] = [];
  async triSourceSettlementFilterChange(filter: CompositeFilterDescriptor) {
    this.trisourceState.filter = filter;
    // console.log(this.TriSourceSettlementState);
    this.triSourcecuurrentPage = 1;
    this.trisourceSettlementSkip = 0;
    this.customFilterState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.customFilterState = _.cloneDeep(this.trisourceState);
    var filterOperators = await this.sharedService.togetFilterOperators(
      this.trisourceState
    );
    // console.log('temp-------------->', filterOperators);
    const iscustomdates = filterOperators?.filter((filter: any) => {
      return filter.value instanceof Date;
    });

    let isEq: any;
    let isNeq: any;
    this.customDateFiltersQueryEq = [];
    this.customDateFiltersQueryNEQ = [];

    if (iscustomdates && iscustomdates.length > 0) {
      isEq = iscustomdates.filter((filter: any) => filter.operator === 'eq');
      isNeq = iscustomdates.filter((filter: any) => filter.operator === 'neq');

      if (isEq.length > 0) {
        this.customDateFiltersQueryEq =
          this.sharedService.customizeFilterQueryEQ(isEq);
        //  console.log('gasQueryString', this.customDateFiltersQueryEq);
      }
      if (isNeq?.length > 0) {
        isNeq.forEach((item: any) => {
          this.customDateFiltersQueryNEQ =
            this.sharedService.customizeFilterQueryNEQ(isNeq);
          // console.log('gasQueryString', this.customDateFiltersQueryNEQ);
        });
      }
    } else {
      isNeq = undefined;
      isEq = undefined;
      this.customDateFiltersQueryEq = [];
      this.customDateFiltersQueryNEQ = [];
    }
    if (
      this.customDateFiltersQueryEq.length > 0 ||
      this.customDateFiltersQueryNEQ.length > 0
    ) {
      let customFilterQueryString =
        await this.sharedService.newmodifyFilterJson(
          this.customFilterState,
          this.customDateFiltersQueryEq,
          this.customDateFiltersQueryNEQ
        );
      this.queryString = this.sharedService.dateFiltercreateQuery(
        customFilterQueryString
      );
    } else {
      this.queryString = this.sharedService.createQuery(this.customFilterState);
    }

    const queryString = this.sharedService.createQuery(this.trisourceState);
    // this.queryString = this.sharedService.createQuery(this.billsInvoice);
    this.getPAi();
    // console.log(queryString);
  }

  async walletUnithistoryFilterChange(filter: CompositeFilterDescriptor) {
    this.WalletUnitState.filter = filter;
    console.log(this.TriSourceSettlementState);
    this.triSourcecuurrentPage = 1;
    this.walletUnitSkip = 0;
    this.customFilterState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.customFilterState = _.cloneDeep(this.WalletUnitState);
    var filterOperators = await this.sharedService.togetFilterOperators(
      this.WalletUnitState
    );
    console.log('temp-------------->', filterOperators);
    const iscustomdates = filterOperators?.filter((filter: any) => {
      return filter.value instanceof Date;
    });

    let isEq: any;
    let isNeq: any;
    this.customDateFiltersQueryEq = [];
    this.customDateFiltersQueryNEQ = [];

    if (iscustomdates && iscustomdates.length > 0) {
      isEq = iscustomdates.filter((filter: any) => filter.operator === 'eq');
      isNeq = iscustomdates.filter((filter: any) => filter.operator === 'neq');

      if (isEq.length > 0) {
        this.customDateFiltersQueryEq =
          this.sharedService.customizeFilterQueryEQ(isEq);
        console.log('gasQueryString', this.customDateFiltersQueryEq);
      }
      if (isNeq?.length > 0) {
        isNeq.forEach((item: any) => {
          this.customDateFiltersQueryNEQ =
            this.sharedService.customizeFilterQueryNEQ(isNeq);
          console.log('gasQueryString', this.customDateFiltersQueryNEQ);
        });
      }
    } else {
      isNeq = undefined;
      isEq = undefined;
      this.customDateFiltersQueryEq = [];
      this.customDateFiltersQueryNEQ = [];
    }
    if (
      this.customDateFiltersQueryEq.length > 0 ||
      this.customDateFiltersQueryNEQ.length > 0
    ) {
      let customFilterQueryString =
        await this.sharedService.newmodifyFilterJson(
          this.customFilterState,
          this.customDateFiltersQueryEq,
          this.customDateFiltersQueryNEQ
        );
      this.walletUitqueryString = this.sharedService.dateFiltercreateQuery(
        customFilterQueryString
      );
    } else {
      this.walletUitqueryString = this.sharedService.createQuery(
        this.customFilterState
      );
    }

    const queryString = this.sharedService.createQuery(this.WalletUnitState);
    // this.queryString = this.sharedService.createQuery(this.billsInvoice);
    this.walletUnitgetPAi();
    console.log(queryString);
  }

  async walletBalancewFilterChange(filter: CompositeFilterDescriptor) {
    this.WalletBalanceState.filter = filter;
    this.walletBalanceSkip = 0;
    this.walletBalancequeryString = this.sharedService.createQuery(
      this.WalletBalanceState
    );
    // console.log(queryString);
    this.walletBalnceApi();
  }

  onSortChange(sort: SortDescriptor[]): void {
    this.trisourceState.sort = sort;
    // console.log(this.TriSourceSettlementState.sort);
    const orderByQuery = this.sharedService.createOrderByQuery(
      this.trisourceState.sort
    );
    this.orderByQuery = orderByQuery;

    this.getPAi();
  }
  walletUnitSortChange(sort: SortDescriptor[]): void {
    this.WalletUnitState.sort = sort;
    // console.log(this.TriSourceSettlementState.sort);
    const orderByQuery = this.sharedService.createOrderByQuery(
      this.WalletUnitState.sort
    );
    this.walletorderByQuery = orderByQuery;

    this.walletUnitgetPAi();
  }
  walletBalanceSortChange(sort: SortDescriptor[]): void {
    this.WalletBalanceState.sort = sort;
    // console.log(this.TriSourceSettlementState.sort);
    const orderByQuery = this.sharedService.createOrderByQuery(
      this.WalletBalanceState.sort
    );
    this.walletBalanceOrderQuery = orderByQuery;

    this.walletBalnceApi();
  }

  triSourcecuurrentPage: number = 1;
  walletunitCurrentpage: number = 1;
  walletBalanceCurrentPage: number = 1;
  protected trisourceSettlementPageChange({
    skip,
    take,
  }: PageChangeEvent): void {
    this.selectedRowdata = [];

    //  console.log('>>>', skip, take);
    this.trisourceSettlementSkip = skip;
    this.pageSize = take;
    this.triSourcecuurrentPage = Math.floor(skip / take) + 1;
    // console.log('currentpage', Math.floor(skip / take) + 1);
    this.getPAi(); //tab 2
  }

  protected walletUitPageChange({ skip, take }: PageChangeEvent): void {
    this.walletUitselectedRowdata = [];
    console.log('>>>', skip, take);
    this.walletUnitSkip = skip;
    this.walletUnitpageSize = take;

    this.walletunitCurrentpage = Math.floor(skip / take) + 1;
    console.log('currentpage', Math.floor(skip / take) + 1);
    this.walletUnitgetPAi(); //tab 1
  }

  protected walletBalancewPageChange({ skip, take }: PageChangeEvent): void {
    this.walletUitselectedRowdata = [];

    console.log('>>>', skip, take);
    this.walletBalanceSkip = skip;
    this.walletBalancepageSize = take;
    this.walletBalanceCurrentPage = Math.floor(skip / take) + 1;
    console.log('>>>', this.walletBalancepageSize);
    console.log('>>>', this.walletUnitpageSize);
    console.log('currentpage', Math.floor(skip / take) + 1);
    this.walletBalnceApi();
  }

  protected trisourceStateChange(state: DataStateChangeEvent): void {
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    //  this.loadBillsInvoiceGridTable();
  }
  protected walletunitStateChange(state: DataStateChangeEvent): void {
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    //  this.loadBillsInvoiceGridTable();
  }

  protected walletBalanceStateChange(state: DataStateChangeEvent): void {
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    //  this.loadBillsInvoiceGridTable();
  }

  public isRowSelected = (rowArg: any) => {
    return this.mySelection.some((row: any) => row.id === rowArg.id);
  };

  selectedRowdata: any = [];
  deselectedRowdata: any = [];
  onSelect(event: any) {
    console.log(event.selectedRows);
    var selectedval = event.selectedRows;
    var deselectedVal = event.deselectedRows;
    if (selectedval.length > 0) {
      selectedval.forEach((element: any) => {
        this.selectedRowdata.push(element.dataItem);
        console.log(' selected Values : ', this.selectedRowdata);
      });
    }
    if (deselectedVal.length > 0) {
      deselectedVal.forEach((element: any) => {
        this.deselectedRowdata.push(element.dataItem);
        console.log('deselectedRowdata Values : ', this.deselectedRowdata);
      });

      if (this.deselectedRowdata.length > 0) {
        const idsToRemove = new Set(
          this.deselectedRowdata.map((item: { id: any }) => item.id)
        );

        const filteredArray = this.selectedRowdata.filter(
          (item: { id: unknown }) => !idsToRemove.has(item.id)
        );
        console.log('', filteredArray);
        this.selectedRowdata = filteredArray;
      }
    }
  }

  walletUitselectedRowdata: any = [];
  walletUnitdeselectedRowdata: any = [];
  walletUnitonSelect(event: any) {
    console.log(event.selectedRows);
    var selectedval = event.selectedRows;
    var deselectedVal = event.deselectedRows;
    if (selectedval.length > 0) {
      selectedval.forEach((element: any) => {
        this.walletUitselectedRowdata.push(element.dataItem);
        console.log(' selected Values : ', this.walletUitselectedRowdata);
      });
    }
    if (deselectedVal.length > 0) {
      deselectedVal.forEach((element: any) => {
        this.walletUnitdeselectedRowdata.push(element.dataItem);
        console.log(
          'deselectedRowdata Values : ',
          this.walletUnitdeselectedRowdata
        );
      });

      if (this.walletUnitdeselectedRowdata.length > 0) {
        const idsToRemove = new Set(
          this.walletUnitdeselectedRowdata.map((item: { id: any }) => item.id)
        );

        const filteredArray = this.walletUitselectedRowdata.filter(
          (item: { id: unknown }) => !idsToRemove.has(item.id)
        );
        console.log('', filteredArray);
        this.walletUitselectedRowdata = filteredArray;
      }
    }
  }

  walletBalanceselectedRowdata: any = [];
  walletBalancedeselectedRowdata: any = [];
  walletBalanceonSelect(event: any) {
    console.log(event.selectedRows);
    var selectedval = event.selectedRows;
    var deselectedVal = event.deselectedRows;
    if (selectedval.length > 0) {
      selectedval.forEach((element: any) => {
        this.walletBalanceselectedRowdata.push(element.dataItem);
        console.log(' selected Values : ', this.walletBalanceselectedRowdata);
      });
    }
    if (deselectedVal.length > 0) {
      deselectedVal.forEach((element: any) => {
        this.walletBalancedeselectedRowdata.push(element.dataItem);
        console.log(
          'deselectedRowdata Values : ',
          this.walletBalancedeselectedRowdata
        );
      });

      if (this.walletBalancedeselectedRowdata.length > 0) {
        const idsToRemove = new Set(
          this.walletBalancedeselectedRowdata.map(
            (item: { id: any }) => item.id
          )
        );

        const filteredArray = this.walletBalanceselectedRowdata.filter(
          (item: { id: unknown }) => !idsToRemove.has(item.id)
        );
        console.log('', filteredArray);
        this.walletBalanceselectedRowdata = filteredArray;
      }
    }
  }

  onSearchInvoicesAds(): void {
    this.triggerSearchSettlement();
    /* if (this.triSourcesearchedValue.length > 0) {
      this.getPAi();
    } */
  }
  walletUnitonSearchInvoicesAds(): void {
    this.triggerSearchwallet();
    /*  if (this.triSourcesearchedValue.length > 0) {
      this.walletUnitgetPAi();
    } */
  }
  walletBalanceSearchInvoicesAds(): void {
    this.triggerSearch();
    /*  if (this.triSourcesearchedValue.length > 0) {
      this.walletBalnceApi();
    } */
  }

  public onValueChange(ev: string): void {
    const trimmedValue = ev.trim();

    // If user enters only spaces — do nothing (just keep the clear icon visible)
    if (trimmedValue.length === 0 && ev.length > 0) {
      return;
    }

    // If user cleared the box (either manually or by clicking the clear icon)
    if (ev.length === 0) {
      this.trisourceSettlementPageChange({ skip: 0, take: this.pageSize });
      //  this.getUsersData();
    }
    /*  if (ev.length == 0) {
      this.trisourceSettlementPageChange({ skip: 0, take: this.pageSize });
      this.getPAi();
    } */
  }
  private triggerSearchSettlement(): void {
    const trimmedValue = this.searchedValue.trim();

    // If only spaces — do nothing
    if (trimmedValue.length === 0 && this.searchedValue.length > 0) {
      return;
    }

    // If empty — load previous data
    if (this.searchedValue.length === 0) {
      this.trisourceSettlementPageChange({ skip: 0, take: this.pageSize });
      this.getPAi();
      return;
    }

    // Otherwise — run search
    this.getPAi();
  }
  public walletUnitonValueChange(ev: string): void {
    const trimmedValue = ev.trim();

    // If user enters only spaces — do nothing (just keep the clear icon visible)
    if (trimmedValue.length === 0 && ev.length > 0) {
      return;
    }

    // If user cleared the box (either manually or by clicking the clear icon)
    if (ev.length === 0) {
      this.walletUitPageChange({ skip: 0, take: this.walletUnitpageSize });
      //  this.getUsersData();
    }
    /* if (ev.length == 0) {
      this.walletUitPageChange({ skip: 0, take: this.walletUnitpageSize });
      this.walletUnitgetPAi();
    } */
  }
  private triggerSearchwallet(): void {
    const trimmedValue = this.searchedValue.trim();

    // If only spaces — do nothing
    if (trimmedValue.length === 0 && this.searchedValue.length > 0) {
      return;
    }

    // If empty — load previous data
    if (this.searchedValue.length === 0) {
      this.walletUitPageChange({ skip: 0, take: this.walletUnitpageSize });
      this.walletUnitgetPAi();
      return;
    }

    // Otherwise — run search
    this.walletUnitgetPAi();
  }
  public walletBalanceonValueChange(ev: string): void {
    const trimmedValue = ev.trim();

    // If user enters only spaces — do nothing (just keep the clear icon visible)
    if (trimmedValue.length === 0 && ev.length > 0) {
      return;
    }

    // If user cleared the box (either manually or by clicking the clear icon)
    if (ev.length === 0) {
      this.walletBalancewPageChange({
        skip: 0,
        take: this.walletUnitpageSize,
      });
      //  this.getUsersData();
    }
    /* if (ev.length == 0) {
      this.walletBalancewPageChange({ skip: 0, take: this.walletUnitpageSize });
      this.walletBalnceApi();
    } */
  }
  private triggerSearch(): void {
    const trimmedValue = this.searchedValue.trim();

    // If only spaces — do nothing
    if (trimmedValue.length === 0 && this.searchedValue.length > 0) {
      return;
    }

    // If empty — load previous data
    if (this.searchedValue.length === 0) {
      this.walletBalancewPageChange({ skip: 0, take: this.walletUnitpageSize });
      this.walletBalnceApi();
      return;
    }

    // Otherwise — run search
    this.walletBalnceApi();
  }
  onFilter(value: any) {
    this.triggerSearchSettlement();
    // this.trisourceSettlementPageChange({ skip: 0, take: this.pageSize });
  }
  walletUitonFilter(value: any) {
    this.triggerSearchwallet();
    // this.walletUitPageChange({ skip: 0, take: this.pageSize });
  }

  walletBalanceonFilter(value: any) {
    this.triggerSearch();
    //this.walletBalancewPageChange({ skip: 0, take: this.pageSize });
  }
  public onExport() {
    console.log(this.TriSourceSettlementgridData.data);
    if (this.TriSourceSettlementgridData.data.length > 0) {
      setTimeout(() => {
        this.hiddenGrid?.saveAsExcel();
      }, 1000);
    } else {
      this.sharedService.showMessageDialog(
        'No data to available',
        '',
        SweetAlertIcon.ERROR
      );
    }
  }

  public walletBalanceonExport(type: string) {
    if (this.walletBalancegridData.data.length > 0) {
      setTimeout(() => {
        this.walletBalancepdfGrid?.saveAsExcel();
      }, 1000);
    } else {
      this.sharedService.showMessageDialog(
        'No data to available',
        '',
        SweetAlertIcon.ERROR
      );
    }
  }
  public walletUnitonExport(type: string) {
    if (this.walletUnitgridData.data.length > 0) {
      setTimeout(() => {
        this.walletUnitpdfGrid?.saveAsExcel();
      }, 1000);
    } else {
      this.sharedService.showMessageDialog(
        'No data to available',
        '',
        SweetAlertIcon.ERROR
      );
    }
  }

  SettleNow() {
    this.Submitted = true;
    /* Object.keys(this.consumerForm.controls).forEach((key) => {
      const control = this.consumerForm.get(key);
      if (control && control.invalid) {
        console.log(`${key} is invalid. Errors:`, control.errors);
      }
    }); */

    let consumerIds = this.consumerForm.get('ConsumerIDs')?.value;
    if (!Array.isArray(consumerIds)) {
      consumerIds = [consumerIds]; // Convert to an array if not already
      this.consumerForm.value.ConsumerIDs = [...consumerIds];
    }
    if (consumerIds.includes('all')) {
      consumerIds = this.ConsumerList.filter(
        (item: any) => item.id !== 'all'
      ).map((item: any) => item.id);
    }

    // console.log(this.consumerForm.value);
    if (this.consumerForm.invalid) {
      return;
    } else {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-primary ms-2',
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: 'Are you sure?',
          text: ` Are you sure, Do You want to Settle Now ? `,
          icon: 'warning',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showCancelButton: true,
        })
        .then((result) => {
          if (result.value) {
            this.loaderService.setLoading(true);
            let payloadData = {
              userIDs: consumerIds,
              projectID: this.currentUserData.project.id,
              unitPrice:
                this.consumerForm.get('UnitRate')?.value == true
                  ? parseFloat(this.consumerForm.get('unitPrice')?.value)
                  : null,
            };
            console.log('payload,', payloadData);
            this.userService.settleTrisourceAmount(payloadData).subscribe({
              next: (res) => {
                if (res.statusCode == 200) {
                  this.sharedService.showMessageDialog(
                    'Success',
                    res.message,
                    SweetAlertIcon.SUCCESS
                  );
                  this.getPAi();
                  this.modelRef_1.hide();
                }
                console.log(res);
                this.loaderService.setLoading(false);
              },
              error: (err) => {
                console.log(err);
                this.sharedService.showMessageDialog(
                  err.error.message,
                  '',
                  SweetAlertIcon.ERROR
                );
                this.loaderService.setLoading(false);
              },
            });
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
          }
        });
    }
  }

  public onSelectConsumers(selectedItems: string[]): void {
    // Ensure selectedItems is an array
    const itemsArray = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];
    // If "All Utilities" is selected, deselect all other utilities
    if (itemsArray.some((item: any) => item.id === 'all')) {
      this.consumerForm.value.ConsumerIDs = ['all'];
      this.consumerForm.patchValue({ ConsumerIDs: ['all'] });
    } else {
      // If "All Utilities" is currently selected and another item is selected, remove "All Utilities"
      if (this.consumerForm.value.ConsumerIDs.includes('all')) {
        const filteredProjectIds = this.consumerForm.value.ConsumerIDs.filter(
          (item: any) => item !== 'all'
        );
        //console.log(filteredProjectIds)
        this.consumerForm.patchValue({ ConsumerIDs: filteredProjectIds });
      } else {
        // Check if all utilities are selected
        const totalUtilityCount = this.ConsumerList.length || 0;
        if (
          this.consumerForm.value.ConsumerIDs.length ===
          totalUtilityCount - 1
        ) {
          this.consumerForm.value.ConsumerIDs = ['all']; // Select "All Utilities" if all individual utilities are selected
          this.consumerForm.patchValue({ ConsumerIDs: ['all'] });
        }
      }
    }
  }
  selectedTabIndex: number = 0;
  tabChange(event: any): void {
    this.customFilterState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };

    this.trisourceState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.WalletUnitState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.orderByQuery = '';
    this.queryString = '';

    this.walletUitqueryString = '';
    this.walletorderByQuery = '';

    this.walletBalanceOrderQuery = '';
    this.walletBalancequeryString = '';

    this.triSourcesearchedValue = '';
    //  console.log(event);
    this.selectedTabIndex = event.selectedIndex;
    // console.log(event.selectedIndex);

    if (this.selectedTabIndex == 0) {
      this.walletBalanceSkip = 0;
      this.walletBalancepageSize = 10;
      if (this.currentUserData.currentUserRoleDetails.role == this.Roles.CONSUMER) {
        this.consumertrisourceFlatdetails();
      }
      else {
        this.walletBalnceApi();
      }

      /* this.walletBalnceApi(); */
    } else if (this.selectedTabIndex == 1) {
      this.walletUnitSkip = 0;
      this.walletUnitpageSize = 10;
      this.walletUnitgetPAi();
    } else {
      this.trisourceSettlementSkip = 0;
      this.pageSize = 10;
      this.getPAi();
    }
  }
}
